(() => {
  function showThanks(form) {
    const panel = form.closest('.wa-ship-modal__panel');
    const fields = form.querySelector('.wa-ship-modal__fields');
    const success = form.querySelector('.wa-ship-modal__success');

    if (panel) {
      panel.querySelectorAll('h3, p').forEach((node) => {
        if (!node.classList.contains('wa-ship-modal__success')) node.hidden = true;
      });
    }

    if (fields) fields.hidden = true;
    if (success) success.hidden = false;
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('.wa-ship-modal')) return;
    if (form.dataset.waShipSending === 'true') {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    form.dataset.waShipSending = 'true';

    let frame = document.getElementById('wa-ship-notify-frame');
    if (!frame) {
      frame = document.createElement('iframe');
      frame.id = 'wa-ship-notify-frame';
      frame.name = 'wa-ship-notify-frame';
      frame.hidden = true;
      document.body.appendChild(frame);
    }

    const native = document.createElement('form');
    native.method = 'post';
    native.action = '/contact';
    native.target = frame.name;
    native.acceptCharset = 'UTF-8';
    native.hidden = true;

    new FormData(form).forEach((value, key) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      native.appendChild(input);
    });

    document.body.appendChild(native);
    native.submit();
    showThanks(form);
  }, true);
})();
